import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import WhatsOn from './pages/WhatsOn';
import EventPage from './pages/EventPage';
import BookDillon from './pages/BookDillon';
import WhiskyList from './pages/WhiskyList';
import DrinksMenu from './pages/DrinksMenu';
import NotFound from './pages/NotFound';
import PlayAtDillon from './pages/PlayAtDillon';
import PayStatus from './pages/PayStatus';
import PayLink from './pages/PayLink';
import PlayGate from './components/apply/PlayGate';
import AdminGate from './pages/admin/AdminGate';
import AdminList from './pages/admin/AdminList';
import AdminDetail from './pages/admin/AdminDetail';
import AdminPayments from './pages/admin/AdminPayments';
import Footer from './components/Footer';
import './index.css';

// Studio and the post plan are admin-only and heavy (image rendering), so they load on demand.
const AdminPosts = lazy(() => import('./pages/admin/AdminPosts'));
const AdminStudio = lazy(() => import('./pages/admin/AdminStudio'));
// the sound crew: engineers at /sound, the crew list at /admin/crew
const SoundPage = lazy(() => import('./pages/sound/SoundPage'));
const AdminCrew = lazy(() => import('./pages/admin/AdminCrew'));
const AdminContacts = lazy(() => import('./pages/admin/AdminContacts'));

// Client-side navigation keeps the scroll position; reset it on each route change.
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
};

function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className="App">
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/events" element={<WhatsOn />} />
                        <Route path="/events/:slug" element={<EventPage />} />
                        <Route path="/bookdillon" element={<BookDillon />} />
                        <Route path="/play" element={<PlayGate><PlayAtDillon /></PlayGate>} />
                        <Route path="/play/apply" element={<Navigate to="/play" replace />} />
                        <Route path="/play/edit/:token" element={<PlayAtDillon />} />
                        <Route path="/play/thanks/:token" element={<PayStatus />} />
                        <Route path="/play/pay/:token" element={<PayStatus />} />
                        <Route path="/admin" element={<AdminGate>{({ session }) => <AdminList session={session} />}</AdminGate>} />
                        <Route path="/admin/payments" element={<AdminGate>{({ session }) => <AdminPayments session={session} />}</AdminGate>} />
                        <Route path="/admin/contacts" element={<AdminGate>{({ session }) => <Suspense fallback={null}><AdminContacts session={session} /></Suspense>}</AdminGate>} />
                        <Route path="/admin/posts" element={<AdminGate>{({ session }) => <Suspense fallback={null}><AdminPosts session={session} /></Suspense>}</AdminGate>} />
                        <Route path="/admin/studio" element={<AdminGate>{({ session }) => <Suspense fallback={null}><AdminStudio session={session} /></Suspense>}</AdminGate>} />
                        <Route path="/admin/crew" element={<AdminGate need="crew">{({ session, staff }) => <Suspense fallback={null}><AdminCrew session={session} staff={staff} /></Suspense>}</AdminGate>} />
                        <Route path="/sound" element={<AdminGate need="sound">{({ session }) => <Suspense fallback={null}><SoundPage session={session} /></Suspense>}</AdminGate>} />
                        <Route path="/pay/:token" element={<PayLink />} />
                        <Route path="/admin/:id" element={<AdminGate>{({ session }) => <AdminDetail session={session} />}</AdminGate>} />
                        <Route path="/whisky" element={<WhiskyList />} />
                        <Route path="/drinks" element={<DrinksMenu />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
            </div>
            <Analytics />
        </Router>
    );
}

export default App;
